import { useEffect, useState } from 'react';
import { apiGet, apiPost } from '../lib/api';
import { useAuth } from '../context/AuthContext';

interface Props {
  displayId: number;
  currentEtat: string;
  onChanged: () => void;
}

interface TransitionsResponse {
  staff: boolean;
  current: string;
  all_states?: string[];
  buttons?: { to: string; label: string }[];
}

export function StateActions({ displayId, currentEtat, onChanged }: Props) {
  const { user } = useAuth();
  const [data, setData] = useState<TransitionsResponse | null>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    const ctl = new AbortController();
    apiGet<TransitionsResponse>(`/api/tickets/${displayId}/transitions`, ctl.signal)
      .then((d) => !ctl.signal.aborted && setData(d))
      .catch(() => {});
    return () => ctl.abort();
  }, [displayId, currentEtat]);

  if (!user || !data) return null;

  const change = async (etat: string) => {
    setBusy(true);
    setErr(null);
    try {
      await apiPost(`/api/tickets/${displayId}/state`, { etat });
      onChanged();
    } catch (e) {
      setErr(e instanceof Error ? e.message : 'Erreur');
    } finally {
      setBusy(false);
    }
  };

  // STAFF : combo libre
  if (data.staff) {
    return (
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <label style={{ fontSize: 'var(--fs-xs)', color: 'var(--text-mute)' }}>Changer l&apos;état :</label>
        <select
          value={data.current}
          onChange={(e) => change(e.target.value)}
          disabled={busy}
          style={{ padding: '5px 10px', border: '1px solid var(--border-strong)', borderRadius: 6, fontSize: 'var(--fs-xs)', background: 'var(--bg)' }}
        >
          {data.all_states?.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
        {err && <span style={{ color: 'var(--danger)', fontSize: 'var(--fs-xs)' }}>{err}</span>}
      </div>
    );
  }

  // CLIENT : boutons contextuels
  const buttons = data.buttons ?? [];
  if (buttons.length === 0) return null;

  return (
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {buttons.map((b) => {
        const isValidate = b.label === 'Valider' || b.label === 'OK Prod';
        return (
          <button
            key={b.to}
            onClick={() => change(b.to)}
            disabled={busy}
            className={isValidate ? 'btn primary' : 'btn'}
            style={{ fontSize: 'var(--fs-xs)' }}
          >
            {b.label}
          </button>
        );
      })}
      {err && <span style={{ color: 'var(--danger)', fontSize: 'var(--fs-xs)' }}>{err}</span>}
    </div>
  );
}
